import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCw05 = function RefreshCw05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.453 12.893c-.2778 2.6099-1.7566 5.0557-4.2036 6.4684-4.0655 2.3472-9.264.9543-11.6112-3.1112l-.25-.433m-.842-4.7102c.2777-2.6099 1.7565-5.0556 4.2035-6.4684 4.0655-2.3472 9.264-.9543 11.6112 3.1112l.25.433M3.4932 18.0662l.732-2.7321 2.732.7321m10.0852-8.132 2.732.732.7321-2.732"
    })
  }));
};
export default RefreshCw05;